module.exports = __webpack_public_path__ + "static/media/oneshot.0d4d8865.jpeg";